import React from "react";

const Home_2=()=>(<div></div>)

export default Home_2;